/* @flow */

import ISOAndCampaignRequest from 'models/requests/marketing/isoAndCampaignRequest';

export default class CallbackRequest {
  leadId: number;
  day: string[];
  hour: string[];
}